import { IFilter } from "../Tools/IFilter";
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from "../Tools/FiltersController";


export class HangFilter implements IFilter {
    id: string;
    name?: string | null;
    type: string;

    controller: FiltersController;
    parentGroup: FilterGroup;

    constructor(parentGroup: FilterGroup) {
        this.id = 'hang';
        this.name = 'Contrainte de pose :';
        this.type = "hang";

        this.controller = new FiltersController();
        this.parentGroup = parentGroup;
    }

    html(): string {
        let html = `
        <span>${this.name}</span>
        <form id="hangForm">
            <input id="hangAll" class="btn-default" type="radio" name="hang" value="ALL"> Tous
            <input id="hangWall" class="btn-default" type="radio" name="hang" value="WALL"> Murs
            <input id="hangFloor" class="btn-default" type="radio" name="hang" value="FLOOR"> Sols
            <input id="hangCeiling" class="btn-default" type="radio" name="hang" value="CEILING"> Plafonds
        </form>
        `;

        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            let form = $('#hangForm');
            form.find('input[type=radio]').each((_index, element) => {
                $(element).prop('checked', FilterGroup.filters.hang === $(element).val());
                this.controller.addEventListener('change', () => {
                    let val = $(element).val() as string;
                    FilterGroup.filters.hang = val;
                    FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
                }, element.id);
            });
        }, 50);
        return html;
    }

    destroy(): void {
        this.controller.destroy();
    }

}